import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import * as z from "zod";
import { useForm } from "react-hook-form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { useCreateScheduleQuery } from "./useCreateScheduleQuery";
import { useEditScheduleQuery } from "./useEditScheduleQuery";
import {
  contractTypes,
} from "../search/FilterValues";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
const FormSchema = z.object({
  query_text: z.string({
    required_error: "This field is required.",
  }),
  frequency: z.string({
    required_error: "This field is required.",
  }),
  notice_type: z.string().nullable().optional(),
});

function CreateQueryForm() {
  const { isLoading: isCreating, mutate: createQuery } =
    useCreateScheduleQuery();
  const [open, setOpen] = useState(false);

  const isWorking = isCreating;

  const form = useForm({
    resolver: zodResolver(FormSchema),
  });

  function onSubmit(data) {
    createQuery(
      { active: true, ...data },
      {
        onSuccess: (data) => {
          setOpen(false);
        },
      }
    );
  }

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger>
          <Button id="schedule-new">Schedule New Alert</Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Schedule New Search </DialogTitle>
            <DialogDescription>
              Schedule a new search and receive email updates based on your
              profile and chosen frequency
            </DialogDescription>
          </DialogHeader>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6 ">
              <FormField
                control={form.control}
                name="query_text"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Search query</FormLabel>
                    <FormDescription>
                      The search query you will be notified about.
                    </FormDescription>
                    <FormControl>
                      <Input
                        disabled={isWorking}
                        placeholder='e.g., "Renovation in Houston, Trucking Contracts, etc."'
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="frequency"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Frequency</FormLabel>
                    <FormDescription>
                      Select how often you want to receive notifications.
                    </FormDescription>
                    <Select
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select a frequency" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="Daily">Daily</SelectItem>
                        <SelectItem value="Weekly">Weekly</SelectItem>
                        <SelectItem value="Monthly">Monthly</SelectItem>
                      </SelectContent>
                    </Select>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="notice_type"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Notice Types (optional)</FormLabel>
                    <FormDescription>
                      Select the notice type you want to receive notifications for.
                    </FormDescription>
                    <Select
                      onValueChange={(value) => field.onChange(value === "none" ? null : value)} 
                      value={field.value || "none"} 
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select a notice type" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="none">All</SelectItem>
                        {contractTypes.map((type) => (
                          <SelectItem key={type} value={type}>
                            {type}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <FormMessage />
                  </FormItem>
                )}
              />


              <div className="ml-auto">
                <Button variant="secondary" onClick={() => setOpen(false)}>
                  Cancel
                </Button>
                <Button type="submit" className="ml-3" disabled={isWorking}>
                  Create new query
                </Button>
              </div>
            </form>
          </Form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CreateQueryForm;